// Copyright (c) 2017 Deere & Company

import Accordion, {getDefaultState as getAccordionDefaultState} from '../../../shared/components/smart-accordion/state/accordion';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import CreateClaimModalType, {getDefaultState as getCreateClaimModalTypeDefaultState} from '../../../shared/state/create-claim-modal';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from '../../../shared/state/search-filters';
import SearchResults, {getDefaultState as getSearchResultsDefaultState} from '../state/search-results';
import t from 'tcomb';

const ClaimSearch = t.struct({
    busyCounter: BusyCounter,
    createClaimModal: CreateClaimModalType,
    facets: Facets,
    filteredSearchResults: SearchResults,
    isEditable: t.Boolean,
    reportsAccordion: Accordion,
    searchFilters: SearchFilters,
    searchResults: SearchResults
}, {
    name: 'ClaimSearch',
    strict: true
});

export const getDefaultState = () =>
    new ClaimSearch({
        busyCounter: getBusyCounterDefaultState(),
        createClaimModal: getCreateClaimModalTypeDefaultState(),
        facets: getFacetsDefaultState(),
        filteredSearchResults: getSearchResultsDefaultState(),
        isEditable: false,
        reportsAccordion: getAccordionDefaultState('claim-search-reports'),
        searchFilters: getSearchFiltersDefaultState(),
        searchResults: getSearchResultsDefaultState()
    });

export default ClaimSearch;



// WEBPACK FOOTER //
// ./src/claim/claim-search/state/index.js